module.exports = __webpack_public_path__ + "static/3-02a9a88506214c6f28e5410a172922f8.png";